import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {SettingsDirectoryService} from '../../services/settings-directory.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: 'settings-directory.component.html'
})
export class SettingsDirectoryComponent implements OnInit, OnDestroy {

    constructor(public settingsDirectoryService: SettingsDirectoryService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.settingsDirectoryService.getUserRoles();
        this.settingsDirectoryService.firstTimeLoading = true;

        this.urlService.onUrlChange
            .pipe(
                tap(
                    () => this.settingsDirectoryService.tabId = this.urlService.queryParams['tab']
                ),
                flatMap(() => this.settingsDirectoryService.getCorporationsByQueryParams(true).pipe(takeUntil(this.urlService.instantOnUrlChange)))
            )
            .subscribe();
        this.urlService.setQueryParams('allSettingsDirectory');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.settingsDirectoryService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.settingsDirectoryService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/settings-directory/settings-directory.component.ts